'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import FinTechNumbers from '@/components/home/fintech-numbers';
import FintechSoftwareDevServices from '@/components/home/fintech-softdev-service';
import AIEnabledFintech from '@/components/technologies/aienabled-fintech-services';
import HireProcessFinTechSoftware from '@/components/technologies/hire-process-fintech-software';
import FinTechCaseStudies from '@/components/home/fintech-case-studies';
import FinTechKeyFocus from '@/components/common/fintech-key-focus';
import WhyChooseMowebFintech from '@/components/common/why-choose-moweb-fintech';
import FintechFAQ from '@/components/faqs/fintech-faq';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroFintechIndustry = dynamic(() => import('@/components/technologies/tech-hero-fintech-industry'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroFintechIndustry />
            <FinTechNumbers />
            <FintechSoftwareDevServices />
            <AIEnabledFintech />
            <HireProcessFinTechSoftware
                bg="bg-agriculture"
                white={true}
                pageTitle="Steps We Follow for FinTech Software Development"
                desc="We ensure every custom fintech solution we build is secure, scalable, and built to deliver measurable results."
            />
            <FinTechCaseStudies />
            <FinTechKeyFocus />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <WhyChooseMowebFintech />
            <TechnologyFaq title="FAQs" bg="bg-aiml">
                <FintechFAQ />
            </TechnologyFaq>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
